export default function TextBox ({firstp, children}){
    return(
        <div className="textitems">
            <div className="firstp">
            
            {firstp}
            
            </div>
            
            {children}
            
        </div>
    )
}